import {
    SET_UTILITY_ANNUAL_INFLATION,
    SET_UTILITY_ANNUAL_KWH,
    SET_UTILITY_ENERGY_VALUE,
    SET_UTILITY_PROVIDER,
    SET_UTILITY_ANNUAL_A_FIXED_CHARGE,
    SET_UTILITY_MONTHLY_KWH_INPUTS,
    SET_UTILITY_MONTHLY_FIXED_INPUTS,
    SET_UTILITY,
} from './constants';

export const setUtility = utility => ({
    type: SET_UTILITY,
    utility,
});
export const setUtilityAnnualKWH = annualKWH => ({
    type: SET_UTILITY_ANNUAL_KWH,
    annualKWH,
});

export const setUtilityEnergyValue = energyValue => ({
    type: SET_UTILITY_ENERGY_VALUE,
    energyValue,
});

export const setUtilityProvider = provider => ({
    type: SET_UTILITY_PROVIDER,
    provider,
});

export const setUtilityAnnualInflation = annualInflation => ({
    type: SET_UTILITY_ANNUAL_INFLATION,
    annualInflation,
});

export const setAFixedCharge = aFixedCharge => ({
    type: SET_UTILITY_ANNUAL_A_FIXED_CHARGE,
    aFixedCharge,
});

export const setMonthlyKWHInputs = (monthlyKWh, month) => ({
    type: SET_UTILITY_MONTHLY_KWH_INPUTS,
    monthlyKWh,
    month,
});

export const setMonthlyFixedInputs = (mFixedCharge, month) => ({
    type: SET_UTILITY_MONTHLY_FIXED_INPUTS,
    mFixedCharge,
    month,
});



// WEBPACK FOOTER //
// ./src/containers/common/utility/actions.js